import { isEqual, parseJSON } from "date-fns";
import { HistoricQuote } from "@api";
import { SecuritiesChartDataWithDate } from "@components";

type MergedHistoricQuote = HistoricQuote & { comparedValue?: number };

export const mergeComparisonQuotesByDate = (
  investmentQuotes: HistoricQuote[],
  compareQuotes: HistoricQuote[]
): MergedHistoricQuote[] => {
  if (!compareQuotes.length) return investmentQuotes;
  return investmentQuotes.map((investmentQuote) => {
    const compareQuote = compareQuotes.find(
      (quote) => quote.date === investmentQuote.date
    );

    return {
      ...investmentQuote,
      comparedValue: compareQuote?.value ?? 0,
    };
  });
};

export const mergeComparisonInvestmentByDate = (
  investmentQuotes: Omit<SecuritiesChartDataWithDate, "areaValue">[],
  compareQuotes: HistoricQuote[]
) => {
  if (!compareQuotes.length) return investmentQuotes;
  return investmentQuotes.map((investmentQuote) => {
    const compareQuote = compareQuotes.find((quote) =>
      isEqual(parseJSON(quote.date), investmentQuote.date)
    );

    return {
      ...investmentQuote,
      comparedValue: compareQuote?.value ?? 0,
    };
  });
};

export const mergeQuotesByDate = (
  investmentQuotes: HistoricQuote[],
  compareQuotes?: HistoricQuote[],
  recommendedQuotes1?: HistoricQuote[],
  recommendedQuotes2?: HistoricQuote[],
  recommendedQuotes3?: HistoricQuote[]
): MergedHistoricQuote[] => {
  if (
    !compareQuotes?.length &&
    !recommendedQuotes1?.length &&
    !recommendedQuotes2?.length &&
    !recommendedQuotes3?.length
  ) {
    return investmentQuotes;
  }

  return investmentQuotes.map((investmentQuote) => {
    let rec1QuoteValue = 0;
    let rec2QuoteValue = 0;
    let rec3QuoteValue = 0;
    let comparedValue = 0;

    if (compareQuotes?.length) {
      const compareQuote = compareQuotes.find(
        (quote) => quote.date === investmentQuote.date
      );

      if (compareQuote) comparedValue = compareQuote.value;
    }
    if (recommendedQuotes1?.length) {
      const recQuote = recommendedQuotes1.find(
        (quote) => quote.date === investmentQuote.date
      );
      if (recQuote) rec1QuoteValue = recQuote.value;
    }
    if (recommendedQuotes2?.length) {
      const recQuote = recommendedQuotes2.find(
        (quote) => quote.date === investmentQuote.date
      );
      if (recQuote) rec2QuoteValue = recQuote.value;
    }
    if (recommendedQuotes3?.length) {
      const recQuote = recommendedQuotes3.find(
        (quote) => quote.date === investmentQuote.date
      );
      if (recQuote) rec3QuoteValue = recQuote.value;
    }

    return {
      ...investmentQuote,
      comparedValue: comparedValue,
      recommender1: rec1QuoteValue ?? 0,
      recommender2: rec2QuoteValue ?? 0,
      recommender3: rec3QuoteValue ?? 0,
    };
  });
};
